// Gestión de usuarios (AdminInstitucion: los de su institución; SuperAdmin: todos).
import { apiFetch, json } from './apiFetch';

export const getUsuarios = (todas = false) =>
  apiFetch(`/api/admin/usuarios${todas ? '?todas=true' : ''}`, { auth: true });

export const getUsuario = (id) =>
  apiFetch(`/api/admin/usuarios/${id}`, { auth: true });

// datos: { nombre, email, password, rol, institucionId?, categoriasRaiz: [] }
export const crearUsuario = (datos) =>
  apiFetch('/api/admin/usuarios', { method: 'POST', auth: true, ...json(datos) });

// datos: { nombre, email, rol, institucionId?, categoriasRaiz: [] }
export const actualizarUsuario = (id, datos) =>
  apiFetch(`/api/admin/usuarios/${id}`, { method: 'PUT', auth: true, ...json(datos) });

export const cambiarEstadoUsuario = (id, activo) =>
  apiFetch(`/api/admin/usuarios/${id}/estado`, { method: 'PATCH', auth: true, ...json({ activo }) });

export const restablecerPassword = (id, passwordNueva) =>
  apiFetch(`/api/admin/usuarios/${id}/password`, { method: 'POST', auth: true, ...json({ passwordNueva }) });

export const eliminarUsuario = (id) =>
  apiFetch(`/api/admin/usuarios/${id}`, { method: 'DELETE', auth: true });
